import * as legends from '../config/legends'

const service = {
  name: 'PolarView',
  authId: 'SmartIce',
  label: 'Polar View',
  logo: 'PolarView',
  iconComponent: 'PolarView',
  disableCoordinates: true,
  weather: true,
  hideDatetimeSlider: true,
  addFeatureToMap: true,
  data: [],
  layers: [
    {
      name: 'SmartIce',
      label: 'Ice travel',
      opacity: 'raster-opacity',
      datetimeId: 'SmartIce',
      legend: {
        type: 'categorical',
        data: legends.polarViewLegend
      }
    },
    {
      name: 'IceDriftDisplacement',
      label: 'Ice Feature Tracking',
      opacity: 'line-opacity',
      datetimeId: 'IceDriftDisplacement',
      exportId: 'IceDriftDisplacement',
      legend: {
        type: 'categorical',
        data: legends.iceDriftLegend
      },
    },
    {
      name: 'SmartIceFeatures',
      label: 'User data',
      opacity: 'circle-stroke-opacity'
    },
    {
      name: 'Sentinel1',
      label: 'Sentinel 1 (75 m)',
      opacity: 'raster-opacity',
      datetimeId: 'Sentinel1',
      secondary: true
    },
    {
      name: 'Sentinel2',
      label: 'Sentinel 2 (10 m)',
      opacity: 'raster-opacity',
      datetimeId: 'Sentinel2',
      secondary: true
    },
    {
      name: 'Modis',
      label: 'Modis (250 m)',
      opacity: 'raster-opacity',
      datetimeId: 'Modis',
      secondary: true
    },
    {
      name: 'CmemsSeaIce',
      label: 'Sea Ice Fraction',
      opacity: 'raster-opacity',
      datetimeId: 'CmemsSeaIce',
      secondary: true,
      legend: {
        type: 'categorical',
        data: legends.cmemsSeaIceLegend
      }
    },
    {
      name: 'CmemsSnowThickness',
      label: 'Snow Thickness',
      opacity: 'raster-opacity',
      datetimeId: 'CmemsSnowThickness',
      secondary: true,
      legend: {
        type: 'categorical',
        data: legends.cmemsSnowThicknessLegend
      }
    },
    {
      name: 'Coastline',
      label: 'Coastline',
      opacity: 'raster-opacity'
    }
  ],
  locations: [
    {
      name: 'Clyde River',
      latitude: 70.35,
      longitude: -69.7,
      maxBounds: [[-78.5, 71], [-60.5, 69]],
      zoom: [7]
    },
    {
      name: 'Qaanaaq',
      latitude: 77.41,
      longitude: -69.79,
      maxBounds: [[-90, 72], [-51, 83]],
      zoom: [6]
    },
    {
      name: 'Grise Fiord',
      latitude: 76.4175,
      longitude: -82.893889,
      // [-90.703125,74.68905341457246],[-74.091796875,74.68905341457246],[-74.091796875,76.67472161047135],[-90.703125,76.67472161047135],[-90.703125,74.68905341457246]
      maxBounds: [[-90.703125, 76.67472161047135], [-74.091796875, 74.68905341457246]],
      // maxBounds: [[-78.5, 71], [-60.5, 69]],
      zoom: [7]
    },
    {
      name: 'Pond Inlet',
      latitude: 72.7012,
      longitude: -78.1579,
      maxBounds: [
        [-85.7, 71.5],
        [-73.1, 72.5]
      ],
      zoom: [7]
    },
    {
      name: 'Resolute',
      latitude: 74.6975,
      longitude: -94.832222,
      zoom: [10]
    },
    // {
    //   name: 'Utqiaġvik',
    //   latitude: 71.30783606806223,
    //   longitude: -156.785888671875,
    //   maxBounds: [[-175, 65], [-140, 76]],
    //   zoom: [6]
    // },
    // {
    //   name: 'Yellowknife',
    //   latitude: 62.442222,
    //   longitude: -114.3975,
    //   maxBounds: [[-120, 59], [-108, 66]],
    //   zoom: [6]
    // }
    {
      name: 'Akulivik',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{"name":"Akulivik"},"geometry":{"type":"Polygon","coordinates":[[[-83.232421875,58.63121664342478],[-72.685546875,58.63121664342478],[-72.685546875,64.62387720204688],[-83.232421875,64.62387720204688],[-83.232421875,58.63121664342478]]]}}
    },
    {
      name: 'Amundsen Gulf',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-129.111328125,68.56038368664157],[-112.939453125,68.56038368664157],[-112.939453125,72.44879155730672],[-129.111328125,72.44879155730672],[-129.111328125,68.56038368664157]]]}}
    },
    {
      name: 'Cape Dorset',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-82.1337890625,62.46156652689498],[-70.59814453125,62.46156652689498],[-70.59814453125,66.21373941545203],[-82.1337890625,66.21373941545203],[-82.1337890625,62.46156652689498]]]}}
    },
    {
      name: 'Coronation Gulf',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-122.51953124999999,66.19600891267761],[-99.140625,66.19600891267761],[-99.140625,71.10254274232307],[-122.51953124999999,71.10254274232307],[-122.51953124999999,66.19600891267761]]]}}
    },
    {
      name: 'Frobisher Bay',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-72.3779296875,61.28079281179158],[-62.84179687499999,61.28079281179158],[-62.84179687499999,64.28275952823394],[-72.3779296875,64.28275952823394],[-72.3779296875,61.28079281179158]]]}}
    },
    {
      name: 'High Arctic',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-99.51416015625,73.65254484149818],[-88.00048828124999,73.65254484149818],[-88.00048828124999,75.90415367803546],[-99.51416015625,75.90415367803546],[-99.51416015625,73.65254484149818]]]}}
    },
    {
      name: 'Hudson Bay',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-96.15234375,53.85252660044951],[-71.54296874999999,53.85252660044951],[-71.54296874999999,64.62387720204688],[-96.15234375,64.62387720204688],[-96.15234375,53.85252660044951]]]}}
    },
    {
      name: 'Igoolik',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-84.83642578125,66.63555577803261],[-72.0703125,66.63555577803261],[-72.0703125,70.17020068549206],[-84.83642578125,70.17020068549206],[-84.83642578125,66.63555577803261]]]}}
    },
    {
      name: 'Jones Sound',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-91.40625,74.95939165894974],[-75.41015624999999,74.95939165894974],[-75.41015624999999,76.94048839176439],[-91.40625,76.94048839176439],[-91.40625,74.95939165894974]]]}}
    },
    {
      name: 'Kugaaruk',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-95.361328125,66.86108230224609],[-83.3203125,66.86108230224609],[-83.3203125,71.41317683396566],[-95.361328125,71.41317683396566],[-95.361328125,66.86108230224609]]]}}
    },
    {
      name: 'Lancaster',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-90.791015625,71.74643171904148],[-75.05859375,71.74643171904148],[-75.05859375,74.79890566232942],[-90.791015625,74.79890566232942],[-90.791015625,71.74643171904148]]]}}
    },
    {
      name: 'Pangnirtung',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-68.66455078125,63.558338036300775],[-59.69970703124999,63.558338036300775],[-59.69970703124999,66.76591933032797],[-68.66455078125,66.76591933032797],[-68.66455078125,63.558338036300775]]]}}
    },
    {
      name: 'Qikiqtarjuaq',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-65.1708984375,66.81787214936938],[-61.23779296875,66.81787214936938],[-61.23779296875,68.19605229820671],[-65.1708984375,68.19605229820671],[-65.1708984375,66.81787214936938]]]}}
    },
    {
      name: 'Southampton',
      zoom: [6],
      longitude: -77.96,
      latitude: 61.63,
      geojson: {"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-91.40625,61.14323525084058],[-75.673828125,61.14323525084058],[-75.673828125,67.5085683629386],[-91.40625,67.5085683629386],[-91.40625,61.14323525084058]]]}}
    }
  ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/PolarView.js